import React, { useContext, useState ,useEffect} from 'react';

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Fade,
  Typography,
} from '@material-ui/core';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import { Store } from '../Store';
import { setTableNumber } from '../actions';
import axios from 'axios';
import config,{getParameterByName,merchantCode} from '../Configs'
import RefreshIcon from '@mui/icons-material/Refresh';
import BackButton from '../components/Back_Button';
import './scrn.css';


export default function HomeScreen(props) {
  const { state, dispatch } = useContext(Store);

  const [tableData,setTableData]=useState([]);
  const styles = useStyles();
  const[tabNum,setTabNum]=useState();
    let {setting} = state.userSetting;
    console.log(setting);
    let {userInfo}= state.userData;
    const baseURL = config.baseURL;
    if(setting){
      let body = document.getElementsByTagName("body");
    body[0].style.backgroundColor = setting.color_tirnary;
     setTimeout(() => {
      let textcolor = document.getElementById("title1");
      let title = document.getElementById("title");
      let name = document.getElementById("name");
      textcolor.style.color = setting.color_secondary;
      title.style.color = setting.color_primary;
      name.style.color = setting.color_primary;
    }, 10);

   }

   const getTables = () => {
     axios.get(`${baseURL}/api/tables?merchantCode=${merchantCode}`).then((res)=>{
        setTableData(res.data);
      })
   }

  //  https://api.menulive.in/api/tables?merchantCode=8D1ZV80O5E
   useEffect(()=>{
    const tablenum = getParameterByName("tableNumber");

if (tablenum){
  
  props.history.push('/order?' + window.location.href.split('?')[1]);
return;
}
    if(!tableData.length){
     getTables();
    }
   },[])

   let wthrurl = window.location.href.split("?")[0];
   let merchant = getParameterByName("merchantCode");
   let isScan = getParameterByName("isScan");

  const gotoTable = (selTabId) => { 
      let merchant = getParameterByName("merchantCode");
    if(selTabId){
      const tabData = tableData?tableData.filter(tab => tab.id ===  selTabId):""
      localStorage.setItem("tableId",tabData[0].id)
     window.location.href =
     wthrurl +
     "?merchantCode=" +
     merchant +
     "&tableNumber=" +tabData[0].number;
    }
   
   
  };

  
  return (
          <Box  id="port-main"  style={{backgroundImage:'url(../images/restaurant-bg.jpg)'}}>
              <Box className={styles.center}>
                    <center>
                              <div className='logo'>
                             {userInfo&&userInfo.logoImg ? <img src={userInfo.logoImg} id='logo-img' style={{height:"auto",width:"300px",maxHeight:"200px"}}/> 
                               : ""}
                              </div>
                        </center>
                    </Box>
        
            <div className={styles.centerWithScrollAndRow} id='choose_cards'>

               {  tableData.map((tab,i)=>{
                    return <Card value={tab.number} onClick={()=>gotoTable(tab.id)} style={{backgroundColor:tab.isAvailable?"#38b14a":"#ac0909",marginLeft:i==0?"auto":"10px",marginRight:i==tableData.length-1?"auto":"10px"}} className="tableCard"><img src={tab.isAvailable?'./images/emtpytbl.png':'./images/busytble.png'} style={{width:"100%",height:"100px"}}/>{'#'+tab.number}
                    <div style={{fontSize:"0.4em",width:"100%",color:"#0eecb7"}}>{'Seats : '+ tab.capacity}</div>
                    <div style={{fontSize:"0.4em",width:"100%",color:"#0eecb7"}}>{tab.notes}</div></Card>
                  })
                }
              
        
            </div>
             <div style={{position:'absolute',zIndex:9999, bottom:"20px", left:"20px" }}>
      <BackButton handleClick={() => props.history.push(`/?` + window.location.href.split('?')[1])} />
      </div>
            <RefreshIcon onClick={getTables} className={"refresh-icon-choose"}/>
          </Box>
          


  );
}
